import { render, staticRenderFns } from "./SInput.vue?vue&type=template&id=2759ae4a&scoped=true&"
import script from "./SInput.vue?vue&type=script&lang=js&"
export * from "./SInput.vue?vue&type=script&lang=js&"
import style0 from "./SInput.vue?vue&type=style&index=0&id=2759ae4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759ae4a",
  null
  
)

export default component.exports